export enum SubscriptionType {
    COMMON = 1,
}
